<template>
    <p class="text-justify" v-html="this.text"></p>
</template>

<script>
    export default {
        props: ['text'],
    };
</script>